export default "__VITE_ASSET__yDCyoLWa__"